/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_RedoInputs */



/**
* | output |
* | --- |
* | "Redo" |
*
* @param {Common_RedoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const common_redo = /** @type {((inputs?: Common_RedoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_RedoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retablir")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wiederholen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rifare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переделать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rehacer")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重做")
	if (locale === "ja") return /** @type {LocalizedString} */ ("やり直す")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फिर से करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Refazer")
	return /** @type {LocalizedString} */ ("Redo")
});